<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title" v-text="title"></div>
        <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button"
            style="width: 85px;margin-bottom: 3px"
        />
        <div class="f-grid-ind">
          <div class="f-grid-col-ind" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
            <div class="ind-text">Công ty</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Khu vực</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="areas_obj.limit" :loading="areas_obj.loading" v-model="areas" :options="areas_obj.items" :total="areas_obj.total" @keyup="emitEventAreas" @offset="changeOffsetAreas" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Bộ phận</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="department_obj.limit" :loading="department_obj.loading" v-model="department" :options="department_obj.items" :total="department_obj.total" @keyup="emitEventAreas" @offset="changeOffsetAreas" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Công việc</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="work_obj.limit" :loading="work_obj.loading" v-model="work" :options="work_obj.items" :total="work_obj.total" @keyup="emitEventWork" @offset="changeOffsetWork" :showClear="true"/>
            </div>
          </div>
        </div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model.sync="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange = 'DataOnChange'
          :company="company"
          :areas="areas"
          :department="department"
          :work="work"
          :cm_id="cm_id"
        ></BaseDatatable>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: null,
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      popupWarning: false,
      areas : {},
      areas_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department : {},
      department_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      work : {},
      work_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      status_check: "YES",
      text_status : "",
      showRegulationsDialog : false,
      control_measures_id : null,
      files : [],
      maxFiles: 10,
      maxFileSize: 10485760*2,
      regulations: 'YES',
      listTypeFile: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "image/jpeg",
        "image/jpg",
        "image/png",
      ],
      control_measures_name : "",
      cm_id : null,
    }
  },
  async created() {
    await this.initParams();
    await this.getListCompany()
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    // let query = Object.assign({}, this.$route.query);
    if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company = {id: this.$route.query.company_id};
        // delete query.company_id;
        // this.$router.replace({ query });
      }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.cm_id)){
        this.cm_id = this.$route.query.cm_id;
        await this.defaultFilter()
        // setTimeout(() => {
        //     const query = Object.assign({}, this.$route.query);
        //     delete query.cm_id;
        //     this.$router.replace({ query });
        // }, 300);
      }
      
      
    }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    'company'() {
      if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company_id = this.company.id;
      }
      var query = Object.assign({}, this.$route.query);
      if(this.company && this.company.id){
        query.company_id = this.company.id
      }else{
        delete query.company_id;
      }
      // this.$router.replace({ query });
      
      this.clearAreas()
      this.clearDepartment()
      this.getListAreas()
      this.getListDepartment()
    },
    async 'areas'(){
      this.componentKey++;
    },
    async 'department'(){
      this.clearWork()
      this.getListWork()
      // this.componentKey++;
    },
    async 'work'(){
      this.componentKey++;
    },
  },
  methods: {
    backToList() {
      this.$router.back();
    },
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_objs = res.data.data.company
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, 'title', this.dataModel.label);
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      actions.rows = function () {
        var buttons = {}
        return buttons
      }
      return actions
    },
    clickYes(){
      this.status_check = "YES"
    },
    clickNo(){
      this.status_check = "NO"
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    },
    async onActionClicked(payload) {
      // console.log("payload==",payload)
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          alert("chưa phát triển")
          // this.dialogMode = action.name
          // if (action.path !== undefined && action.path) {
          //   this.$router.push({ path: action.path + data.data[action.key] })
          // } else  {
          //   this.editId = data.data[action.key]
          //   this.displayDialog = true
          //   this.editDialogKey++
          // }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
        case 'evaluation':
          // console.log("data-evaluation",data.data)
          this.control_measures_id = data.data.id
          this.control_measures_name = data.data.name
          this.showRegulationsDialog = true
          break
        case 'history':
          console.log("data.data",data.data)
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          // this.$router.push({ path: action.path ,query: { page_transaction: pageTransaction.toString(), company_id: this.company_id ,efd_id:data.data.id}  })
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/control_measures/delete", {control_measures_id: that.deleteId, company_id: that.company.id}, {headers}).then(function () {
          that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
          that.$commonFuction.is_loading(false);
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          })
        })
      }
    },
    emitEventAreas(keyword) {
      // console.log(keyword);
      this.$delete(this.areas_obj.filters, 'name');
      if (keyword) {
        this.areas_obj.filters.name = keyword;
      }
      this.getListAreas();
    },
    changeOffsetAreas(value) {
      this.areas_obj.offset = value;
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.areas_obj.loading = true;
        await ApiRepository.post("/_api/area/options", {filters: this.areas_obj.filters, limit: this.areas_obj.limit, offset: this.areas_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.areas_obj.offset > 0 ) {
              this.areas_obj.items.push(...res.data.data.area);
            } else{
              this.areas_obj.items = res.data.data.area;
            }
            this.areas_obj.total = res.data.data.count;
            this.areas_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.areas_obj.loading = false;
        })
      }
    },
    emitEventDepartment(keyword) {
      // console.log(keyword);
      this.$delete(this.department_obj.filters, 'name');
      if (keyword) {
        this.department_obj.filters.name = keyword;
      }
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.department_obj.filters.active = true;
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.department_obj.loading = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.count;
            this.department_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    emitEventWork(keyword) {
      // console.log(keyword);
      this.$delete(this.work_obj.filters, 'name');
      if (keyword) {
        this.work_obj.filters.name = keyword;
      }
      this.getListWork();
    },
    changeOffsetWork(value) {
      this.work_obj.offset = value;
    },
    async getListWork() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.$delete(this.work_obj.filters, 'department_id');
      if(!this.$commonFuction.isEmptyObject(this.department)){
        this.work_obj.filters.department_id = this.department.id
      }
      this.work_obj.filters.active = true
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        this.work_obj.loading = true;
        await ApiRepository.post("/_api/work/options", {filters: this.work_obj.filters, limit: this.work_obj.limit, offset: this.work_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.work_obj.offset > 0 ) {
            this.work_obj.items.push(...res.data.data.list);
          } else{
            this.work_obj.items = res.data.data.list;
          }
          this.work_obj.total = res.data.data.total;
          this.work_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.work_obj.loading = false;
        })
      }
    },
    clearAreas(){
      this.areas_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.areas = {}
    },
    clearWork(){
      this.work_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.work = {}
    },
    clearDepartment(){
      this.department_obj ={
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.department = {}
    },
    isImage(file) {
      // return /^image\//.test(file.type);
      return this.listTypeFile.includes(file.type);
    },
    async onFileDownload(index) {
      let file = this.files[index];
      window.open(file.objectURL);
    },
    reloadPage(){
      this.componentKey++
      this.showRegulationsDialog = false
      this.$commonFuction.is_loading(false);
    },
    async defaultFilter() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        var object = {
          control_measures_id : this.cm_id,
          company_id: this.company.id
        }
        var data = null
        await ApiRepository.post("/_api/control_measures/detail_normal", object, {headers}).then(async (res) => {
          data = res.data.data
        })
        // console.log("data===",data)
        if(data){
          var evaluation_form_name = data.evaluation_form_name
          var situation_name = ''
          var danger_name = ''
          var control_measures_name = data.name ?? ''
          if(data.situation && data.situation.type == 'other'){
            situation_name = data.other_situation_name
          }else{
            situation_name = data.situation_name
          }
          if(data.danger && data.danger.type == 'other'){
            danger_name = data.other_danger_name
          }else{
            danger_name = data.danger_name
          }
          var obj = {
            evaluation_form_name : evaluation_form_name,
            situation_name: situation_name,
            danger_name : danger_name,
            control_measures_name : control_measures_name,
          }
          console.log("obj==",obj)
          this.filters =obj
        }
      }
      this.componentKey++;
    },
  },
}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}

/* .p-button-warning .pi-times{
  color: #e95d57;
} */
.f-grid-ind {
  display: flex;
  margin-left: -1rem;
  flex-flow: row wrap;
}

.f-grid-col-ind {
  width: 25% !important;
  padding: 0rem 0rem 0rem 1rem;
}
.ind-text { 
  font-weight: 600;
}
.idn-sel {
  margin-top: -6px;
}
.p-button-warning-o .p-button-label{
  color: #333333;
}
.p-button-warning-o .pi-times{
  color: #333333;
}
.callback-btn-o {
  border-color: #00000029 !important;
  background-color: #00000029 !important;
}
.text-box-a{
  display: block;
  width : 100%;
}
</style>